import { useMutation } from "react-query";
import { searchUsers } from "../../../admin/user-roles/lib/userData";

const userStatus = {
    activeStatus: "1",
    valueName: "isActive",
};

export const useSearchUsers = () => {
    return useMutation(({ searchParams, pagingParams }) => {
        const params = pagingParams.reduce((param, { id, value }) => {
            // TODO: temporary, remove this when pagination will be unified
            if (id === "pageNumber") {
                value += 1;
            }

            // TODO: temporary, remove this when pagination will be unified
            if (id === "order") {
                return {
                    ...param,
                    orderBy: value,
                };
            }

            return {
                ...param,
                [id]: encodeURIComponent(value),
            };
        }, []);
        const filters = searchParams.reduce((filter, { id, value }) => {
            if (id === userStatus.valueName) {
                return {
                    ...filter,
                    [id]: value === userStatus.activeStatus,
                };
            }

            return {
                ...filter,
                [id]: value.split(",").map((filerValue) => filerValue.trim()),
            };
        }, []);

        return searchUsers({
            ...params,
            searchUsersFilters: {
                ...filters,
            },
        });
    });
};
